var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.showSkonto
    ? _c(
        "div",
        { staticClass: "col-12" },
        [
          _vm.variationTotalPrice
            ? [
                _c("div", { staticClass: "my-4" }, [
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$translate(
                          "ZeitloungeTheme::Template.articleSkontoHtmlText"
                        )
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("currency")(
                            _vm.skontoPrice,
                            _vm.currentVariation.prices.default.currency
                          )
                        ) +
                        " * \n      "
                    ),
                  ]),
                ]),
              ]
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }